import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default payload => {
  let searchParams = '';
  if (payload) searchParams = `company: "${payload}"`;

  if (payload && typeof payload === 'object') {
    searchParams = convertFilterRequestUrl(payload, []);
    return gql`
    query {
      getUniqueProductSubType(input: ${searchParams} ) {
        productSubType
      }
    }
  `;
  }
  return gql`
  query {
    getUniqueProductSubType(input: { ${searchParams} }) {
      productSubType
    }
  }
`;
};
